module.exports = __webpack_public_path__ + "media/images/team/rebecca-95c542415cbaf0417b084c048523eb34.jpg";